module.exports = __webpack_public_path__ + "media/images/star-e506fabb.svg";